import { Injectable } from "@angular/core";
import {
  HttpClient,
  HttpBackend,
  HttpErrorResponse,
} from "@angular/common/http";
import { environment } from "src/environments/environment";
import { throwError, Observable } from "rxjs";
import { catchError } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class LoanApplicationService {
  constructor(
    private http: HttpClient,
    private httpClient: HttpClient,

    handler: HttpBackend
  ) {
    this.httpClient = new HttpClient(handler);
    this.token = localStorage.getItem("currentClient");
  }

  token: string;

  private API = "/api/loan/";

  handleError(error: HttpErrorResponse) {
    return throwError(error);
  }

  getListLoansApplicant(): Observable<any> {
    return this.http
      .get(this.API + "loan-list-for-group-loan-applicant")
      .pipe(catchError(this.handleError));
  }

  getListLoansBackOffice(payload): Observable<any> {
    return this.http
      .get(this.API + "loan-list-for-back-office", {
        params: payload,
      })
      .pipe(catchError(this.handleError));
  }

  saveLoanApplication(payload): Observable<any> {
    return this.http
      .post(this.API + "saveLoanApplication", payload)

      .pipe(catchError(this.handleError));
  }
  updateLoanApplication(payload): Observable<any> {
    return this.http
      .post(this.API + "saveLoanApplication", payload)

      .pipe(catchError(this.handleError));
  }
  saveLoanAttachments(payload): Observable<any> {
    return this.http
      .post(this.API + "saveLoanApplicationAttachment", payload)

      .pipe(catchError(this.handleError));
  }

  getLoanAttachments(payload): Observable<any> {
    return this.http
      .get(this.API + "LoanApplicationAttachment", {
        params: payload,
      })

      .pipe(catchError(this.handleError));
  }

  submitLoanApplicationToWDC(payload): Observable<any> {
    return this.http
      .get(this.API + "submitLoanApplication" + "/" + payload)

      .pipe(catchError(this.handleError));
  }

  viewLoanApplicationStatus(payload): Observable<any> {
    return this.http
      .get(this.API + "LoanApplicationStatus", {
        params: payload,
      })

      .pipe(catchError(this.handleError));
  }

  saveLoanApplicationStatus(payload): Observable<any> {
    return this.http
      .post(this.API + "saveloanApplicationStatus", payload)

      .pipe(catchError(this.handleError));
  }

  deleteAttachedDocuments(payload): Observable<any> {
    return this.http
      .get(this.API + "deleteLoanApplicationAttachment", {
        params: payload,
      })
      .pipe(catchError(this.handleError));
  }
  getLoanAttachmentTypes(): Observable<any> {
    return this.http
      .get("/api/loan-document-types")
      .pipe(catchError(this.handleError));
  }

  accountVerification(params): Observable<any> {
    return this.http
      .get("/api/integration/bank", { params: params })
      .pipe(catchError(this.handleError));
  }

  accountsVerification(params): Observable<any> {
    return this.http
      .get("/api/integration/banks", { params: params })
      .pipe(catchError(this.handleError));
  }
  bankCodes(): Observable<any> {
    return this.http.get("/api/banks/banks").pipe(catchError(this.handleError));
  }

  economicBySector(param): Observable<any> {
    return this.http
      .get("/api/economic-activities/sector/" + param)
      .pipe(catchError(this.handleError));
  }

  sectors(): Observable<any> {
    return this.http.get("/api/sectors").pipe(catchError(this.handleError));
  }

  saveGroupActivities(payload): Observable<any> {
    return this.http
      .post("/api/group/saveGroupEconomicActivity", payload)

      .pipe(catchError(this.handleError));
  }
}
